import React from "react";
import logo from "../../assets/logo.png";
import colorIcon from "../../assets/color_icon.svg";
import artistImage from "../../assets/artist_image.svg";
import eventImage from "../../assets/event.png";
import homeImage from "../../assets/home_image.svg";
import resultContestIcon from "../../assets/create_contest_icon.svg";
import requestContestIcon from "../../assets/contest_request_icon.svg";
import dollerIcon from "../../assets/dollar_icon.svg";
import earningIcon from "../../assets/earning.svg";
import rewardIcon from "../../assets/reward_1.svg";
import planIcon from "../../assets/freepricing_icon.png";

import { NavLink } from "react-router-dom";

export const AdminSidebar = () => {

const requestedStatusCode=120;
const allStatusCode=0;

  const admin = [

     {path: "/admin", label: "Home", icon: homeImage },
     {path: `/admin/contests/${allStatusCode}`, label: "All Contests", icon: colorIcon },
     {path: `/admin/contests/${requestedStatusCode}`, label: "Contest Requests", icon: requestContestIcon },
    //  {path: '/admin/contest-results', label: "Contest Results", icon: resultContestIcon },
     {path: "/admin/events", label: "Events", icon: eventImage },
     {path: "/admin/artists", label: "Artists", icon: artistImage },
     {path: "/admin/subscribe-plans", label: "Subscribe Users", icon: planIcon },
     {path: "/admin/rewards", label: "Rewards", icon: rewardIcon },
     {path: "/admin/revenue", label: "Revenue", icon: dollerIcon },
     {path: "/admin/earnings", label: "Events Earning", icon: earningIcon },
     {path: "/admin/create-contest", label: "Create Contest", icon: resultContestIcon },
   
  ];

  const menuItems =admin;

  return (
    <div className="relative w-full h-full flex flex-col items-center">
      {/* Logo */}
      <div className="flex items-center justify-center">
        <div className="w-[70px] h-[71px] ">
          <img
            src={logo}
            alt="Loading"
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Navigation Part */}
      <div className="pt-7 px-7 w-full flex items-center justify-center">
        <ul className="flex flex-col">
          {menuItems.map((item) => (
            <li key={item.path} className="relative mb-[6px]">
              <NavLink
                to={item.path}
                end={item.path === "/user" || item.path === "/artist" || item.path === "/admin"}
                className={({ isActive }) =>
                  `px-[19px] py-3 flex items-center justify-start gap-2 outline-none  rounded-[10px] ${isActive
                    ? "text-white font-bold bg-primary"
                    : "text-black hover:bg-primary hover:text-white"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span className="absolute -left-3 top-1/2 transform -translate-y-1/2 h-5 w-[3px] bg-primary rounded-r-md"></span>
                    )}
                    <img src={item.icon} alt="icon" className="w-5 h-5" />
                    <span className="font-medium text-xs font-grotesk tracking-wider">
                      {item.label}
                    </span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>

  
    </div>
  );
};
